import { render, staticRenderFns } from "./Submit2.vue?vue&type=template&id=008869a2&scoped=true"
import script from "./Submit2.vue?vue&type=script&lang=js"
export * from "./Submit2.vue?vue&type=script&lang=js"
import style0 from "./Submit2.vue?vue&type=style&index=0&id=008869a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008869a2",
  null
  
)

export default component.exports